import { atom, useSetRecoilState, useRecoilValue, selector } from 'recoil';
import { CreditNote } from '../pages/credit_note/interface/CreditNote.Interface';

// Types
interface StatusInfo {
  // Add your status info properties here
  [key: string]: any;
}

interface CreditNoteEdit {
  // Add your credit note properties here
  [key: string]: any;
}

export interface CreditNoteState {
  credit_note: CreditNote[];
  status_info: StatusInfo[];
}

// Atoms
export const creditNoteAtom = atom<CreditNoteState>({
  key: 'Credit_note_atom',
  default: { credit_note: [], status_info: [] },
});

export const creditNotEditAtom = atom<CreditNoteEdit>({
  key: 'Credit_note_edit_atom',
  default: {},
});

// Hooks
export const SetCreditNoteListAtom = () => useSetRecoilState(creditNoteAtom);
export const GetCreditNoteListAtom = () => useRecoilValue(creditNoteAtom);

export const SetEditCreditNoteAtom = () => useSetRecoilState(creditNotEditAtom);
export const GetEditCreditNoteAtom = () => useRecoilValue(creditNotEditAtom);
